import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';

function SystemEmailTemplatesWrapPageView({
  header,
  footer,
  jurisdictions,
  selectedJurisdictionId,
  selectedLanguage,
  languageOptions,
  isJurisdictionsLoading,
  isLoading,
  isSaving,
  error,
  success,
  listLink,
  setHeader,
  setFooter,
  changeJurisdiction,
  changeLanguage,
  saveWrap,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <FloatingAlerts error={error} success={success} />
      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>{t('emailTemplates.wrapTitle')}</h2>
          <p>{t('emailTemplates.wrapSubtitle')}</p>
        </div>
        <div className="d-flex gap-2">
          <Link className="btn btn-default" to={listLink}>
            {t('emailTemplates.backToList')}
          </Link>
          <button type="button" className="btn btn-primary" onClick={saveWrap} disabled={isLoading || isSaving}>
            {isSaving ? t('emailTemplates.savingInfo') : t('common.save')}
          </button>
        </div>
      </div>

      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <div className="row g-3">
            <div className="col-12 col-md-6">
              <label className="form-label mb-1">{t('emailTemplates.jurisdictionLabel')}</label>
              <select
                className="form-select"
                value={selectedJurisdictionId}
                onChange={(event) => changeJurisdiction(event.target.value)}
                disabled={isJurisdictionsLoading || isSaving}
              >
                {jurisdictions.length === 0 ? <option value="">{t('emailTemplates.noJurisdictions')}</option> : null}
                {jurisdictions.map((item) => (
                  <option key={item.id} value={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label mb-1">{t('emailTemplates.languageLabel')}</label>
              <select
                className="form-select"
                value={selectedLanguage}
                onChange={(event) => changeLanguage(event.target.value)}
                disabled={isSaving}
              >
                {languageOptions.map((code) => (
                  <option key={code} value={code}>{code}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="card card-body mt-3">
          {isLoading ? (
            <div className="text-muted">{t('common.loading')}</div>
          ) : (
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">{t('emailTemplates.headerLabel')}</label>
                <textarea
                  className="form-control font-monospace"
                  rows="12"
                  value={header}
                  onChange={(event) => setHeader(event.target.value)}
                  disabled={isSaving}
                />
              </div>
              <div className="col-12">
                <label className="form-label">{t('emailTemplates.footerLabel')}</label>
                <textarea
                  className="form-control font-monospace"
                  rows="12"
                  value={footer}
                  onChange={(event) => setFooter(event.target.value)}
                  disabled={isSaving}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SystemEmailTemplatesWrapPageView;
